export const completeNameValidator = (value: unknown, optional: boolean = false): boolean => {
  if (typeof value !== 'string') {
    return false;
  }

  const sentences = value
    .trim()
    .split(' ')
    .filter((sentence) => sentence.length > 0);

  if (optional && sentences.length === 0) {
    return true;
  }

  return sentences.length >= 2;
};
